import { checkIsGoogleMap } from 'shared/utils';

import { googleMapApi } from './googleMapApi';
import { hereMapApi } from './hereMapApi';

import { GeocodeProps } from '../types';

export const mapApi = {
  getPredictedPlaces: (search: string) => {
    if (checkIsGoogleMap()) {
      return googleMapApi.getPredictedPlaces(search)
    } else {
      return hereMapApi.getPredictedPlaces(search);
    }
  },
  geocode: (props: GeocodeProps) => {
    if (checkIsGoogleMap()) {
      return googleMapApi.geocode(props)
    } else {
      return hereMapApi.geocode(props);
    }
  }
};
